import { Component, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { ConfigService } from './config.service';
import { AddConfigComponent } from './add-config/add-config.component';
import { EditConfigComponent } from './edit-config/edit-config.component';
import { IConfigUpdatePayload } from './config.interface';

@Component({
	selector: 'app-config-settings',
	templateUrl: './config-settings.component.html',
	styleUrls: ['./config-settings.component.scss'],
})
export class ConfigSettingsComponent {
	@ViewChild(DataTableDirective, { static: false })
	dtElement!: DataTableDirective;

	isLoading = false;
	selectedValue: string = '-1';

	dtOptions: any = {};
	dtTrigger: Subject<any> = new Subject<any>();
	dtInstance!: DataTables.Api;

	dtLink =
		environment.interop.basePath +
		environment.interop.platform.app.settings.configurations.getConfigurations +
		'-dt';

	parameters: { key: string; value: string }[] = [
		{ key: '--Alegeți--', value: '-1' },
		{ key: 'Active', value: '0' },
		{ key: 'Public', value: '1' },
	];

	onSelectionChange(event: any): void {
		this.selectedValue = event.value;
	}

	dataTablesParameters: any = {
		data: {
			key: this.selectedValue,
		},
	};
	constructor(
		private dialogService: DialogService,
		private http: HttpClient,
		private dialog: MatDialog,
		private configService: ConfigService
	) { }

	ngOnInit(): void {
		this.renderDT();
	}

	ngOnDestroy(): void {
		this.dtTrigger.unsubscribe();
	}

	ngAfterViewInit(): void {
		this.dtTrigger.next('');
	}

	renderDT() {
		this.isLoading = true;
		this.dtOptions = {
			serverSide: true,
			responsive: true,
            pageLength: 25,

			ajax: (dataTablesParameters: any, callback: any) => {
				dataTablesParameters.param1 = this.selectedValue;

				this.http
					.post<DataTablesResponse>(this.dtLink, dataTablesParameters)
					.subscribe((resp: any) => {
						this.isLoading = false;
						callback({
							recordsTotal: resp.data.recordsTotal,
							recordsFiltered: resp.data.recordsFiltered,
							data: resp.data.data,
						});
					});
			},
			language: environment.config.romanianLanguageDataTable,
			columns: [
				{
					title: 'ID',
					data: 'id_configuration',
				},
				{
					title: 'Denumire',
					data: 'name',
				},
			],
			rowCallback: (row: Node, data: any[] | any) => {
				const lastTd = (row as HTMLElement).querySelector('td:last-child');
				const editIcon = lastTd?.querySelector('.edit');
				const deleteIcon = lastTd?.querySelector('.delete');

				if (editIcon) {
					editIcon.addEventListener('click', () => {
						this.openEditDialog(data);
					});
				}

				if (deleteIcon) {
					deleteIcon.addEventListener('click', () => {
						const { id } = data;
						this.deleteConfig(id);
					});
				}

				return row;
			},
		};
	}

	rerenderDT(): void {
		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
			// Destroy the table first
			dtInstance.destroy();
			// Call the dtTrigger to rerender again
			this.dtTrigger.next('');
		});
	}

	openAddDialog() {
		const dialogRef = this.dialog.open(AddConfigComponent, {
			...this.dialogService.getDialogConfig(),
		});
		dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
			if (success) {
				this.rerenderDT();
			}
		});
	}

	openEditDialog(data: IConfigUpdatePayload) {
		const dialogRef = this.dialog.open(EditConfigComponent, {
			...this.dialogService.getDialogConfig(),
			data,
		});

		dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
			if (success) {
				this.rerenderDT();
			}
		});
	}

	// No delete API

	deleteConfig(configId: number) {
		Swal.fire({
			title: 'Sunteți sigur?',
			text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#DD6B55',
			confirmButtonText: 'Confirm!',
			cancelButtonText: 'Cancel',
			showLoaderOnConfirm: true,
		}).then((result) => {
			if (result.isConfirmed) {
				this.configService.deleteConfig(configId).subscribe(() => {
					this.rerenderDT();
					Swal.fire({
						title: 'Șters!',
						text: 'Funcție ștearsă cu succes.',
						icon: 'success',
						confirmButtonText: 'OK',
					});
				});
			}
		});
	}
}
